/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SubOfficeDetailsDto } from '@gh/builder-shared-data';
import { cast } from '@gh/core-util';
import { omit } from 'lodash';
import { getDefaultEmail, getEmailLocalName } from '@gh/common-shared';
export type SubOfficeDetails = SubOfficeDetailsDto & {
  applyLicense: boolean;
};

export const SUB_OFFICE_INIT = {
  officeId: '',
  status: 'Active',
  email: '',
  companyName: '',
  displayName: '',
  systemName: '',
  // tslint:disable-next-line:no-null-keyword
  taxId: null,
  // tslint:disable-next-line:no-null-keyword
  abn: null,
  // tslint:disable-next-line:no-null-keyword
  acn: null,
  tradingAs: '',
  // tslint:disable-next-line:no-null-keyword
  gst: null,
  street1: '',
  street2: '',
  city: '',
  state: '',
  postCode: '',
  // tslint:disable-next-line:no-null-keyword
  licenseNo: null,
  phoneOffice: '',
  fax: '',
  phoneMobile: '',
  isPublicListed: false,
};

export function subOfficeDetailsToDto(details: SubOfficeDetails): SubOfficeDetailsDto {
  return cast<SubOfficeDetailsDto>(omit({
    ...details,
                                          // tslint:disable-next-line:no-null-keyword
    licenseNo: details.applyLicense ? details.licenseNo : null,
    email: getDefaultEmail(details.email),
  },
                                        'applyLicense'));
}

export function subOfficeDetailsFromDto(details: SubOfficeDetailsDto): SubOfficeDetails {
  return {
    ...details,
    email: details.email && getEmailLocalName(details.email),
    applyLicense: !!details.licenseNo,
  };
}
